module.exports = __webpack_public_path__ + "static/media/bnr2.9d4a017f.jpg";